import { useFusionAuth } from '@fusionauth/react-sdk';
import { ROLES } from '../constants/roles';

export const usePermissions = () => {
  const { user } = useFusionAuth();
  const userRoles = user?.roles || [];

  return {
    canAccessCoachMaintenance: () => userRoles.includes(ROLES.COACH_MAINTENANCE),
    canAccessRMM: () => userRoles.includes(ROLES.RMM_ACCESS),
    canAccessEditOffer: () => userRoles.includes(ROLES.OFFER_ADMIN),
    canAccessPerformance: () => userRoles.includes(ROLES.PERFORMANCE_VIEW),
    canAccessBookManagement: () => userRoles.includes(ROLES.BOOK_MANAGEMENT),
    canAdjustCredits: () => userRoles.includes(ROLES.CREDITS_ADJUST),
    canCancelBookOrders: () => userRoles.includes(ROLES.PRINT_SHOP_CANCEL),
    canAssignAccountManagers: () =>
      userRoles.includes(ROLES.ACCOUNT_MANAGER_ADMIN),
  };
};
